<template>
  <div class="wrapper">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-content">
        <h2 class="page-title">
          <i class="el-icon-s-grid title-icon"></i>
          {{ $route.meta.name }}
        </h2>
        <el-button 
            v-checkbtn="isShowBtn(AUTH_BTN.dept_list_add)" 
            type="primary" 
            size="small" 
            class="add-btn"
            @click="addRootDept"
        >
          <i class="el-icon-plus"></i>
          <span>新增</span>
        </el-button>
      </div>
    </div>

    <div class="treeArea">
      <!-- 左侧部门树 -->
      <el-card class="tree-card" shadow="never">
        <div slot="header" class="card-header">
          <i class="el-icon-menu"></i>
          <span>部门列表</span>
        </div>
        <div class="tree">
          <el-tree
            ref="tree"
            node-key="id"
            highlight-current
            :data="treeData"
            :props="defaultProps"
            :expand-on-click-node="false"
            :default-expand-all="true"
            @node-click="handleNodeClick"
          ></el-tree>
        </div>
      </el-card>

      <!-- 分隔线 -->
      <div class="line" v-show="currentDept.id"></div>

      <!-- 右侧部门详情 -->
      <el-card class="content-card" shadow="never" v-show="currentDept.id">
        <div slot="header" class="card-header">
          <i class="el-icon-info"></i>
          <span>部门详情</span>
        </div>
        <div class="content">
          <div class="dept-name">{{ currentDept.deptName }}</div>
          <div class="action-buttons">
            <el-button 
                :disabled="!isShowBtn(AUTH_BTN.dept_list_edit)" 
                type="primary" 
                size="small"
                class="action-btn"
                @click="editDept"
            >
              <i class="el-icon-edit"></i>
              <span>编辑</span>
            </el-button>

            <el-popconfirm :title="`确定删除部门【${currentDept.deptName}】吗`" @confirm="removeDept">
              <el-button 
                  :disabled="!isShowBtn(AUTH_BTN.dept_list_del)" 
                  type="danger" 
                  size="small"
                  class="action-btn"
                  slot="reference"
              >
                <i class="el-icon-delete"></i>
                <span>删除</span>
              </el-button>
            </el-popconfirm>
            
            <el-button 
                :disabled="!isShowBtn(AUTH_BTN.dept_list_add)" 
                type="success" 
                size="small"
                class="action-btn"
                @click="addDept"
            >
              <i class="el-icon-plus"></i>
              <span>新增子部门</span>
            </el-button>
          </div>
        </div>
      </el-card>
    </div>

    <!-- 弹窗 -->
    <el-dialog 
        :title="title" 
        :visible.sync="dialogVisible" 
        width="900px" 
        class="dept-dialog"
    >
      <div class="scroll-wrap">
        <el-form ref="form" :model="formData" label-width="130px" class="dept-form">
          <el-form-item label="当前的部门为：" v-show="formData.parentId != 0">
            <span class="parent-dept-name">{{ currentDept.deptName }}</span>
          </el-form-item>
          <el-form-item label="部门名称" prop="deptName" :rules="rules">
            <el-input v-model="formData.deptName" placeholder="请输入部门名称" clearable class="form-input"></el-input>
          </el-form-item>
          <el-form-item label="负责人" prop="leaderName" :rules="rules">
            <el-input v-model="formData.leaderName" placeholder="请输入负责人姓名" clearable class="form-input"></el-input>
          </el-form-item>
          <el-form-item label="负责人手机号" prop="leaderMobile" :rules="rules">
            <el-input v-model="formData.leaderMobile" placeholder="请输入负责人手机号" clearable class="form-input"></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="sort" :rules="rules">
            <el-input v-model="formData.sort" placeholder="请输入排序" clearable class="form-input"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" v-model="formData.remark" placeholder="请输入备注（选填）" :rows="4" class="form-textarea"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">取 消</el-button>
        <el-button type="primary" @click="save" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { authBtnMixin } from '@/mixins/authBtnMixin';
import { getDeptTree, removeDept, addDept, editDept, getDeptDetail } from './api';

export default {
  name: 'SystemDeptList',
  mixins: [authBtnMixin],
  data() {
    return {
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'deptName'
      },
      formData: {
        deptName: '',
        remark: '',
        parentId: null,
        sort: '',
        leaderName: '',
        leaderMobile: ''
      },
      rules: [{ required: true, message: '该项不能为空', trigger: 'blur' }],
      level: '', //菜单等级
      currentDept: {}, //树形的每项数据
      dialogVisible: false,
      title: ''
    }
  },
  mounted() {
    this.getDeptTree();
  },
  watch: {
    treeData: {
      handler() {
        if (this.treeData.length > 0 && !this.currentDept.id) {
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.treeData[0].id);
            this.currentDept = this.$refs.tree.getCurrentNode();
          })
        }
      }
    }
  },
  methods: {
    async getDeptTree() {
      const res = await getDeptTree();
      this.treeData = res || [];
      if (this.currentDept.id) {
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.currentDept.id);
          this.currentDept = this.$refs.tree.getCurrentNode();
        })
      }
    },
    handleNodeClick(data, node) {
      this.level = node.level;
      this.currentDept = data;
    },
    addDept() {
      this.title = '新增子部门';
      this.dialogVisible = true;
      this.initFormData();
      this.$nextTick(() => {
        this.$refs.form.resetFields();
      })
      this.formData.parentId = this.currentDept.id;
    },
    addRootDept() {
      this.title = '新增部门';
      this.dialogVisible = true;
      this.initFormData();
      this.formData.parentId = 0
      this.$nextTick(() => {
        this.$refs.form.resetFields();
      })
    },
    async removeDept() {
      await removeDept(this.currentDept.id).then(() => {
        this.$message.success('删除成功');
        this.getDeptTree();
        this.level = '';
        this.currentDept = {};
      })
    },
    async editDept() {
      this.title = '编辑部门';
      this.dialogVisible = true;
      await this.getDeptDetail();
    },
    async getDeptDetail() {
      const deptId = this.currentDept.id;
      const res = await getDeptDetail(deptId);
      this.formData = res;
      this.formData.parentId = res.parentId;
    },
    save() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (this.formData.id) {
            // 编辑
            await editDept(this.formData).then(() => {
              this.$message.success('编辑成功');
              this.getDeptTree();
              this.dialogVisible = false;
            })
          } else {
            // 新增
            await addDept(this.formData).then(() => {
              this.$message.success('新增成功');
              this.getDeptTree();
              this.dialogVisible = false;
              this.level = '';
              this.currentDept = {};
            })
          }
        }
      })
    },
    cancel() {
      this.dialogVisible = false
    },
    initFormData() {
      this.formData = {
        deptName: '',
        remark: '',
        parentId: null,
        sort: '',
        leaderName: '',
        leaderMobile: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  background: linear-gradient(180deg, #f0f2f5 0%, #fafbfc 50%, #ffffff 100%);
  padding: 20px;
  min-height: calc(100vh - 84px);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 200px;
    background: linear-gradient(135deg, rgba(64, 158, 255, 0.05) 0%, rgba(102, 177, 255, 0.02) 100%);
    pointer-events: none;
    z-index: 0;
  }
}

// 页面标题区域
.page-header {
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
  
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 24px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
  }
  
  .page-title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #1a1e25;
    display: flex;
    align-items: center;
    gap: 12px;
    letter-spacing: -0.5px;
    
    .title-icon {
      font-size: 24px;
      background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
  }
  
  .add-btn {
    border-radius: 10px;
    padding: 8px 20px;
    font-weight: 600;
    font-size: 13px;
    background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
    border: none;
    box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    letter-spacing: 0.3px;
    display: inline-flex;
    align-items: center;
    gap: 6px;

    &:hover:not(.is-disabled) {
      background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
      box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
    }
  }
}

.treeArea {
  display: flex;
  gap: 20px;
  position: relative;
  z-index: 1;
  
  .tree-card {
    width: 320px;
    flex-shrink: 0;
    border-radius: 16px;
    border: none;
    background: #ffffff;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: linear-gradient(90deg, #409EFF 0%, #66b1ff 50%, #85c1ff 100%);
    }
    
    &:hover {
      box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
      transform: translateY(-2px);
    }
    
    .card-header {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 16px;
      font-weight: 600;
      color: #303133;
      
      i {
        font-size: 18px;
        margin-right: 8px;
      }
    }
    
    ::v-deep .el-card__body {
      padding: 20px;
    }
    
    .tree {
      .el-tree ::v-deep {
        .el-tree-node__content {
          height: 40px;
          border-radius: 8px;
          margin-bottom: 4px;
          transition: all 0.3s ease;
          
          &:hover {
            background: rgba(64, 158, 255, 0.08);
          }
          
          .el-tree-node__expand-icon {
            margin-left: 20px;
            color: #909399;
          }
        }
        
        .el-tree-node.is-current > .el-tree-node__content {
          background: linear-gradient(90deg, rgba(64, 158, 255, 0.15) 0%, rgba(102, 177, 255, 0.08) 100%);
          border-right: 3px solid #409EFF;
          
          .el-tree-node__label,
          .el-tree-node__expand-icon {
            color: #409EFF;
            font-weight: 600;
          }
          
          .el-tree-node__expand-icon.is-leaf {
            color: transparent !important;
          }
        }
      }
    }
  }
  
  .line {
    width: 1px;
    background: linear-gradient(180deg, transparent 0%, #e4e7ed 20%, #e4e7ed 80%, transparent 100%);
    flex-shrink: 0;
  }
  
  .content-card {
    flex: 1;
    min-width: 0;
    border-radius: 16px;
    border: none;
    background: #ffffff;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: linear-gradient(90deg, #409EFF 0%, #66b1ff 50%, #85c1ff 100%);
    }

    &:hover {
      box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
      transform: translateY(-2px);
    }

    .card-header {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 16px;
      font-weight: 600;
      color: #303133;
      
      i {
        font-size: 18px;
        margin-right: 8px;
      }
    }

    ::v-deep .el-card__body {
      padding: 24px;
    }
    
    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: 300px;
      gap: 30px;
      
      .dept-name {
        font-size: 32px;
        font-weight: 700;
        color: #303133;
        text-align: center;
        background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
      
      .action-buttons {
        display: flex;
        gap: 12px;
        flex-wrap: wrap;
        justify-content: center;
        
        .action-btn {
          border-radius: 10px;
          padding: 10px 20px;
          font-weight: 600;
          font-size: 13px;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          display: inline-flex;
          align-items: center;
          gap: 6px;
          
          &:hover:not(.is-disabled) {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          }
          
          &:active {
            transform: translateY(0);
          }
        }
      }
    }
  }
}

// 对话框样式
.dept-dialog {
  ::v-deep .el-dialog {
    border-radius: 8px;
    overflow: hidden;
  }

  ::v-deep .el-dialog__header {
    background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
    padding: 20px 24px;
    border-bottom: none;

    .el-dialog__title {
      color: #fff;
      font-size: 18px;
      font-weight: 600;
    }

    .el-dialog__close {
      color: #fff;
      font-size: 20px;

      &:hover {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }

  ::v-deep .el-dialog__body {
    padding: 24px;
    background: #f5f7fa;
  }

  ::v-deep .el-dialog__footer {
    padding: 16px 24px;
    background: #fff;
    border-top: 1px solid #e4e7ed;
  }

  ::v-deep .el-form-item__label {
    font-weight: 500;
    color: #606266;
    font-size: 14px;
  }

  ::v-deep .el-form-item {
    margin-bottom: 20px;
  }
}

.scroll-wrap {
  max-height: 65vh;
  overflow-y: auto;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;

    &:hover {
      background: #a8a8a8;
    }
  }
}

.dept-form {
  .parent-dept-name {
    font-weight: 600;
    color: #409EFF;
    font-size: 15px;
  }

  .form-input {
    width: 100%;
    max-width: 400px;

    ::v-deep .el-input__inner {
      border-radius: 4px;
      transition: all 0.3s ease;
      text-align: left;

      &:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
      }

      &:hover {
        border-color: #c0c4cc;
      }
    }
  }

  .form-textarea {
    width: 100%;
    max-width: 500px;

    ::v-deep .el-textarea__inner {
      border-radius: 4px;
      transition: all 0.3s ease;
      resize: vertical;

      &:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
      }

      &:hover {
        border-color: #c0c4cc;
      }
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  .el-button {
    padding: 10px 24px;
    border-radius: 4px;
    font-weight: 500;
    transition: all 0.3s ease;

    &.el-button--primary {
      background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
      border: none;

      &:hover {
        background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
        box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
        transform: translateY(-2px);
      }
    }

    &:not(.el-button--primary) {
      &:hover {
        color: #409EFF;
        border-color: #409EFF;
        background-color: #ecf5ff;
      }
    }
  }
}

// 响应式设计
@media (max-width: 1400px) {
  .wrapper {
    padding: 16px;
  }
  
  .treeArea {
    gap: 16px;
    
    .tree-card {
      width: 280px;
    }
  }
}

@media (max-width: 1200px) {
  .treeArea {
    flex-direction: column;
    
    .tree-card {
      width: 100%;
    }
    
    .line {
      width: 100%;
      height: 1px;
      margin: 20px 0;
    }
  }
}

@media (max-width: 768px) {
  .wrapper {
    padding: 12px;
  }
  
  .page-header .header-content {
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    
    .page-title {
      font-size: 20px;
    }
  }
  
  .treeArea {
    gap: 12px;
  }
  
  .tree-card,
  .content-card {
    border-radius: 12px;
    
    ::v-deep .el-card__body {
      padding: 16px;
    }
  }
  
  .content-card {
    .content {
      .dept-name {
        font-size: 24px;
      }
      
      .action-buttons {
        flex-direction: column;
        width: 100%;
        
        .action-btn {
          width: 100%;
          justify-content: center;
        }
      }
    }
  }
  
  .dept-dialog {
    ::v-deep .el-dialog {
      width: 95% !important;
      margin: 5vh auto !important;
    }
  }

  .dept-form {
    .form-input,
    .form-textarea {
      max-width: 100% !important;
    }
  }
}
</style>
